import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useState } from 'react';
import { defaultCommentData } from '../../pages/WMS_SMS/data';

export default function CommentEditModal({ commentData, setCommentData, updateQuoteLineComments = null }) {
    const [input, setInput] = useState(null);

    return (
        <Transition.Root show={commentData?.open} as={Fragment}>
            <Dialog as='div' className='relative z-30' onClose={() => setCommentData(defaultCommentData)}>
                <div className='flex fixed top-0 left-0 justify-center items-center w-full h-full'>
                    <Transition.Child
                        as={Fragment}
                        enter='ease-out duration-300'
                        enterFrom='opacity-0'
                        enterTo='opacity-100'
                        leave='ease-in duration-200'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'
                    >
                        <div className='fixed inset-0 z-20 w-screen h-screen bg-gray-500 bg-opacity-40 transition-opacity' />
                    </Transition.Child>
                    <div className='relative flex flex-col items-end justify-between h-[400px] w-[500px] border rounded-md px-5 pb-5 pt-3 bg-white gap-y-3 z-30'>
                        <h1 className='w-full text-lg text-center'>{!commentData?.readonly && 'External '}Comments</h1>
                        <textarea
                            defaultValue={commentData?.comments}
                            onChange={(e) => setInput(e.target.value)}
                            className='px-2 py-1 w-full h-full rounded-md border'
                            readOnly={commentData?.readonly}
                        />
                        <section className='flex flex-row gap-x-5 justify-evenly w-full h-fit'>
                            <button
                                className='px-2 py-1 w-full text-black bg-gray-300 rounded-md disabled:opacity-40'
                                onClick={() => setCommentData(defaultCommentData)}
                            >
                                {commentData?.readonly ? 'Close' : 'Cancel'}
                            </button>
                            {!commentData?.readonly && (
                                <button
                                    className='px-2 py-1 w-full text-white rounded-md bg-blue-primary disabled:opacity-40'
                                    onClick={() => {
                                        updateQuoteLineComments(commentData.quoteLineId, input);
                                    }}
                                >
                                    Submit
                                </button>
                            )}
                        </section>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
